import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Select from 'react-select';

import 'assets/scss/soonoGetStarted.css';
import SignUpWrapper from 'containers/SignUpWrapper';
import { TRIAL_SIGNUP_ROUTES, ROUTES, insertIdtoUrl } from 'constants/Routes';
import { FREE_SIGNUP_STEPS } from 'constants/Transactions';
import { REG_EXP } from 'constants/index';
import { checkValidity, handleFormValidate } from 'utils/formvalidate';
import InputField from './InputField';
import {
  setContactDetails,
  removeContactDetails,
  setBillingDetails,
  getNonce,
  getBusinessId,
  getSelectedPlan,
  getBillingDetails,
  setPlanSubscriptionStatus,
} from 'constants/localStorageManager';
import statesList from 'constants/AmericanStates';
import BusinessApi from 'apis/Business';

import CardImage from 'assets/img/credit-card-payment.jpg';
import Toaster from '../Toaster';
import ReviewSubscription from './ReviewSubscription';

const assignFormValuetoKeys = formValues => {
  const formKeys = Object.keys(formValues);
  const formData = {};

  formKeys.forEach(key => {
    formData[key] = formValues[key].value;
  });

  return formData;
};

class PaymentStepAddress extends Component {
  constructor() {
    super();
    this.state = {
      formValues: {
        addressLine1: {},
        addressLine2: {},
        city: {},
        country: {
          value: 'USA',
        },
        state: {},
        zip: {},
      },
      reviewPayment: false,
    };
  }

  componentDidMount() {
    this.prefillZip();
  }

  prefillZip = () => {
    const { zip } = getNonce() || {};
    const { formValues } = this.state;
    const _formValues = { ...formValues };
    _formValues.zip.value = zip;
    this.setState({ formValues: _formValues });
  };

  handleSubmit = e => {
    e.preventDefault();
    const form = this.refs.billingAddressForm;
    const { hasErrors, formValues } = handleFormValidate(form);
    const hasValidState = !this.validateStateSelection();
    const updatedFormValues = { ...this.state.formValues, ...formValues };

    this.setState({ hasErrors, formValues: updatedFormValues });
    if (!hasErrors && hasValidState) this.updateBillingDetails();
  };

  updateBillingDetails = () => {
    const { location, renew } = this.props;
    const { formValues } = this.state;
    const billingDetails = assignFormValuetoKeys(formValues);

    setBillingDetails(billingDetails);
    this.setState({ reviewPayment: true });
  };

  getBillingAddressAttributes = () => {
    const {
      addressLine1: address_line_1,
      addressLine1: address_line_2,
      city,
      state,
      zip,
      country,
    } = getBillingDetails() || {};
    const { nonce, billing_name } = getNonce() || {};
    return {
      address_line_1,
      address_line_2,
      city,
      state,
      zip,
      country,
      billing_name,
      is_primary: true,
      nonce,
    };
  };

  updatePlan = () => {
    const plan_subscription_attributes = getSelectedPlan();
    const billing_addresses_attributes = [this.getBillingAddressAttributes()];

    const updateData = {
      business: {
        plan_subscription_attributes,
        billing_addresses_attributes,
      },
    };

    BusinessApi.update(getBusinessId(), updateData)
      .then(({ data }) => {
        const { plan_subscription } = data;
        setPlanSubscriptionStatus(plan_subscription);
        Toaster.getSuccessToaster('check-circle', 'Successfully updated plan');
        this.changeStep();
      })
      .catch(() => {
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Failed to update plan'
        );
      });
  };

  changeStep = currentPathName => {
    const { renew } = this.props;
    const businessId = getBusinessId();
    const currentStepObj = FREE_SIGNUP_STEPS.find(
      step => step.path == currentPathName
    );
    const currentStepNumber = FREE_SIGNUP_STEPS.indexOf(currentStepObj);
    const nextStep = FREE_SIGNUP_STEPS[currentStepNumber + 1];
    const pushUrl = renew
      ? insertIdtoUrl(ROUTES.BUSINESS_USER_DETAIL, businessId)
      : nextStep.path;
    this.props.history.push(pushUrl);
  };

  handleChange = e => {
    const { name, value, required, type } = e.target;
    const _state = { ...this.state };
    const hasError = checkValidity({ name, value, type, required });
    _state.formValues[name] = {
      value,
      hasError,
    };

    this.setState({ ..._state });
  };

  handleStateChange = e => {
    const { formValues } = this.state;
    const state = {};
    state.value = e ? e.value : null;

    this.setState({ formValues: { ...formValues, state } });
  };

  validateStateSelection = () => {
    const { formValues } = this.state;
    const { state } = formValues;
    let hasError = true;
    if (state.value) {
      hasError = false;
    }
    state.hasError = hasError;

    this.setState({ formValues: { ...formValues, state } });
    return hasError;
  };

  render() {
    const { location, renew } = this.props;
    const { formValues, reviewPayment } = this.state;
    const { state } = formValues;

    if (reviewPayment) return <ReviewSubscription renew={renew} />;

    return (
      <SignUpWrapper
        step={TRIAL_SIGNUP_ROUTES.CONTACT_DETAILS}
        currentStep={location.pathname}
        renew={renew}
      >
        <div className="col-md-6 offset-md-3">
          <h3 className="mt-5 mb-2 text-dark" style={{ fontWeight: 600 }}>
            Enter Your Billing Address
          </h3>
          <p className="text-secondary">
            Your payment method will be applied to your next billing cycle.
          </p>
          <form
            ref="billingAddressForm"
            className="form mt-4 mb-5 text-left text-dark soono-transaction-form"
          >
            <div className="form-group">
              <InputField
                formValues={formValues}
                type="text"
                label="Street Address 1"
                placeholder=""
                name="addressLine1"
                handleChange={this.handleChange}
                required
              />
            </div>
            <div className="form-group">
              <InputField
                formValues={formValues}
                type="text"
                label="Street Address 2"
                placeholder=""
                name="addressLine2"
                handleChange={this.handleChange}
              />
            </div>
            <div className="row">
              <div className="form-group col-md-7">
                <InputField
                  formValues={formValues}
                  type="text"
                  label="City"
                  placeholder=""
                  name="city"
                  handleChange={this.handleChange}
                  required
                />
              </div>
              <div class="form-group col-md-5 state-select">
                <label for="state">State</label>
                <Select
                  name="state"
                  className="section"
                  options={statesList}
                  onChange={this.handleStateChange}
                  onBlur={this.handleStateSelectBlur}
                  value={state.value}
                  removeSelected
                  clearable={false}
                  required
                />
                {state.hasError && (
                  <div className="row error" id="categoryError">
                    State is required
                  </div>
                )}
              </div>
            </div>
            <div className="row  mb-2">
              <div class="form-group col">
                <InputField
                  formValues={formValues}
                  type="text"
                  label="ZIP Code"
                  placeholder=""
                  name="zip"
                  handleChange={this.handleChange}
                  required
                />
              </div>
              <div className="form-group col">
                <InputField
                  formValues={formValues}
                  type="text"
                  label="Country"
                  placeholder=""
                  name="country"
                  value="USA"
                  handleChange={this.handleChange}
                  isDisabled
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <button
                className="btn-warning btn-lg col-md-12 py-3 pl-5 pr-5 text-white text-bold border-0"
                type="button"
                onClick={this.handleSubmit}
              >
                Review payment
              </button>
            </div>
            <div className="row">
              <div className="col-md-7">
                <p className="text-center text-secondary d-block mt-2">
                  7 Day Free Trial. Cancel at Anytime!
                </p>
              </div>
              <div className="col-md-4 offset-md-1">
                <img className="card-payment-img" src={CardImage} />
              </div>
            </div>
          </form>
        </div>
      </SignUpWrapper>
    );
  }
}

export default withRouter(PaymentStepAddress);



// WEBPACK FOOTER //
// ./src/components/transactions/PaymentStepAddress.js